module.exports = __webpack_public_path__ + "static/endgame-7a1e273119d8cc2eaba6a22235146073.jpg";